import React, { useState } from "react";
import { Box } from "@mui/material";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const DateRangeSelectorV2 = ({ value, onChange }) => {
  const [dateRange, setDateRange] = useState(
    value && value[0] && value[1] ? [new Date(value[0]), new Date(value[1])] : []
  );

  const handleDateRangeChange = (value) => {
    if (value && value.length === 2) {
      const [start, end] = value;

      const adjustedStart = new Date(start);
      const adjustedEnd = new Date(end);

      if (
        adjustedStart.toDateString() === adjustedEnd.toDateString() &&
        adjustedStart.getTime() === adjustedEnd.getTime()
      ) {
        adjustedStart.setHours(0, 0, 0, 0);
        adjustedEnd.setHours(24, 0, 0, 0);
      }

      const adjustedValue = [adjustedStart, adjustedEnd];
      setDateRange(adjustedValue);
      onChange(adjustedValue);
    } else {
      setDateRange(value || []);
      onChange(value || []);
    }
  };

  const getDateTimePickerRange = () => {
    if (!dateRange || dateRange.every((dateFilter) => !dateFilter)) {
      return [];
    } else {
      return dateRange;
    }
  };

  const handleShortcutClick = (range) => {
    if (range.label === "today") {
      const today = new Date();
      const start = new Date(today.setHours(7, 0, 0, 0));
      const end = new Date(today.setHours(23, 0, 0, 0));
      const newRange = [start, end];

      handleDateRangeChange(newRange);
    } else {
      console.log("Shortcut clicked:", range);
    }
  };

  return (
    <Box>
      <DateRangePicker
        format="MM/dd/yyyy hh:mm:ss a"
        showMeridiem={true}
        value={getDateTimePickerRange()}
        style={{ width: "460px" }}
        label="From ~ To:"
        onChange={(rangeValue) => handleDateRangeChange(rangeValue)}
        cleanable
        onShortcutClick={handleShortcutClick}
        onSelect={(date) => {
          console.log('date', date);
        }}
      />
    </Box>
  );
};

export default DateRangeSelectorV2;